import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProviderUserPage = lazy(() => import('../views/list/AccountProviderUserPage'));

export function AccountProviderUserPageLazy() {
	return (
		<PageSuspense>
			<AccountProviderUserPage />
		</PageSuspense>
	);
}
